import {useTranslation} from "react-i18next";

import {Price} from "./Price";
import {PricingBoxBase} from "./PricingBoxBase";

const SUBSCRIPTION_PRICE = "276";
const FLTR_LANDING_URL = "https://fltr.rynekpierwotny.pl/#/portal/signup";

export const FLTRPricingBox = () => {
    const {t} = useTranslation();

    return (
        <PricingBoxBase title={t("pricing.fltr_subscription.description")}>
            <Price
                isFLTR
                price={SUBSCRIPTION_PRICE}
                primaryButton={{text: t("pricing.learn_more"), href: FLTR_LANDING_URL}}
            />
        </PricingBoxBase>
    );
};
